import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/product/ai/page.tsx");
